<template>
    <judicial-recovery-enterprise-page nature="Falência" back-to="/falencia" />
</template>
<script>
import JudicialRecoveryEnterprisePage from './JudicialRecoveryEnterprisePage.vue';
export default { name: 'BankRuptcyEnterprisePage', components: { JudicialRecoveryEnterprisePage } };
</script>
